import { NavisionDocumentApiModel } from "./NavisionDocumentApiModel";

export class AccountStatementEmailSendRequestApiModel {
    testMode: boolean;
    reportOnly: boolean;
    attachReservesList: boolean;
    statements: Array<NavisionDocumentApiModel>;
}